import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getPubAbbr } from "@revbox/helpers-fe";
import { cookiesKeyNames } from "@revbox/common-fe";

import { setUser } from "../features/user";
import { getMe } from "../services/micro";
import { loadersModule } from "../modules/loaders";
import { getPublisher } from "../services/pub";
import { mixpanelInstance } from "../mixpanel/instance";
import { useCookiesContext } from "../contexts/CookiesContext";

const handleMixpanelTracking = (user) => {
  try {
    mixpanelInstance.people.set(user.id, {
      $firstname: user.first_name,
      $lastname: user.last_name,
      $email: user.email,
      $role: user.role,
      $publisherId: user.publisher_id,
    });
    mixpanelInstance.track("Sign Up", { "Signup Type": "Login" });
  } catch (error) {
    console.error("Error in Mixpanel people.set:", error);
  }
};

export const Auth = ({ children }) => {
  const { updateCookiesProperty, cookiesData, getPathKey } =
    useCookiesContext();

  const [isLoading, setIsLoading] = useState(true);
  const [publisherId, setPublisherId] = useState(null);
  const [storedPublisherId, setStoredPublisherId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const advertiserId =
    cookiesData[getPathKey()]?.[cookiesKeyNames.advertiserId];
  const publisherIdByCookies =
    cookiesData[getPathKey()]?.[cookiesKeyNames.publisherId];

  useEffect(() => {
    const publisherIdByAbbr = getPubAbbr();
    const publisherId = publisherIdByCookies || publisherIdByAbbr;
    setPublisherId(publisherId);
    setStoredPublisherId(publisherIdByCookies);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoGif = loadersModule(publisherId);

  const fetchUser = async () => {
    const handlePublisherResponse = async (publisherId) => {
      if (!publisherId) return;

      const publisherResponse = await getPublisher(publisherId);

      if (publisherResponse?.success) {
        const abbreviation = publisherResponse?.data?.abbreviation;
        updateCookiesProperty(cookiesKeyNames.abbreviation, abbreviation);
      } else {
        // toast.error("Cannot get publisher");
        // navigate("/pages/signin"); // publisher case (withoud advId)
      }
    };
    // each time
    try {
      // Publisher case
      if (storedPublisherId) {
        return await handlePublisherResponse(storedPublisherId);
      }

      // No data in cookies
      else {
        let response = null;

        // Advertiser case
        if (advertiserId) {
          response = await getMe(null, advertiserId);
        }

        // Publisher case
        else {
          response = await getMe();
        }

        if (!response) {
          console.error("#1 Error fetching user data");
          navigate("/pages/signin");
          return;
        }
        if (!response.success || !response.data) {
          console.error("#2 Error fetching user data");
          navigate("/pages/signin");
          return;
        }
        const user = response.data;
        user.token = response.token;

        handleMixpanelTracking(user);
        dispatch(setUser(user));
        updateCookiesProperty(cookiesKeyNames.publisherId, user.publisher_id);
        updateCookiesProperty(cookiesKeyNames.language, user.language, user.account_id);
        updateCookiesProperty(cookiesKeyNames.advertiserId, user.account_id, user.account_id);
        updateCookiesProperty(cookiesKeyNames.token, user.token, user.account_id)
        updateCookiesProperty(cookiesKeyNames.tourAdvInit, user.tour_adv_init.toString(), user.account_id);
        updateCookiesProperty(cookiesKeyNames.tourAdvBidding, user.tour_adv_bidding.toString(), user.account_id);
        updateCookiesProperty(cookiesKeyNames.email, user.email);
        updateCookiesProperty(cookiesKeyNames.userId, user.id);
        await handlePublisherResponse(user.publisher_id);
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      // navigate("/pages/signin");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      // setIsLoading(false);
    }
  };

  useLayoutEffect(() => {
    fetchUser();
  }, [window.location.pathname]);

  if (isLoading) {
    if (publisherId) {
      return <Form className="page-sign dark">{logoGif}</Form>;
    } else {
      return <></>;
    }
  } else {
    return <>{children}</>;
  }
};
